import React from 'react';
import inspirationBackground from '../assets/Frame.svg';

function InspirationSection() {
  return (
    <section className="relative py-20 md:py-40 lg:py-60 overflow-hidden">
      <img 
        src={inspirationBackground} 
        alt="Hero Background" 
        className="absolute inset-0 w-full h-full object-cover object-center" 
      />
      <div className="relative container mx-auto px-4">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold font-montserrat mb-4 md:mb-6">
          Miles de aventuras a un click de distancia.
        </h1>
        <p className="text-base md:text-lg lg:text-xl font-open-sans mb-4">
          Complí ese sueño que tanto querés
        </p>
      </div>
    </section>
  );
}

export default InspirationSection;